import { useContext } from 'react';
import { CensusFiltersContext } from '../contexts/CensusFiltersContext';

export const useCensusFiltersContext = () => {
    return useContext(CensusFiltersContext);
};
